import * as React from "react";
import { Theme } from "@mui/styles";
import { cloneDeep } from "lodash";
// import ChipWidth from "./chip-hook"
import {
  TextField,
  Chip,
  Paper,
  InputAdornment,
  FormControl,
  IconButton,
  ClickAwayListener,
  Popper,
  Fade,
  Avatar,
  Hidden,
} from "@mui/material";
import { TextFieldProps } from "material-ui";
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';

import NumberFormat from "react-number-format";
import { extend } from "lodash";

interface Props extends TextFieldProps {
  value?: any;
  error?: any;
  helperText?: any;
  InputLabelProps?: any;
  inputRef?: any;
  InputProps?: any;
  inputProps?: any;
  label?: any;
  disabled?: any;
  name?: any;
  placeholder?: any;
  required?: any;
  type?: any;
  id?: any;
  onBlur?: any;
  onKeyPress?: any;
  onChange?: any;
  readOnly?: any;
  className?: any;
  onKeyDown?: any;
  onCommitChange?: any;
  labelStyleObj?: any;
  style?: any;
  shrink?: any;
  margin?: any;
  precision?: any;
  isKeyField?: boolean;
  fieldDefinition?: any;
}

// ATTENTION: this is the max value for postgres int4
const POSTGRES_MAX_INT = 2147483647;

type State = {
  value: any;
  chipLimit: number;
  chipSkip: number;
  popperOpen: number;
  anchorEl: any;
  localError?: any;
  localWarning?: any;
};

const styles = (theme: Theme): StyleRules => ({
  chip: {
    margin: `${theme.spacing()}px ${theme.spacing() / 4}px`,
  },
  displayText: {
    marginTop: 16,
    fontSize: "1.05rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  popperPaper: {
    padding: "10px 0px 0px 10px",
  },
});

class ChipField extends React.Component<
  Props & WithStyles<typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      value: this.props.value,
      chipLimit: -1,
      popperOpen: -1,
      chipSkip: 0,
    };

    this.fieldRef = React.createRef();
    this.chipsRef = [];
  }

  fieldRef: any;
  lastCollectiveWidth: number;
  lastMaxChips: number;
  chipsRef: any;
  popperNode: any;

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (nextProps.value != this.state.value) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

 componentDidMount() {
    const { fieldDefinition } = this.props;

    if (
      fieldDefinition &&
      fieldDefinition.chipAttributes &&
      fieldDefinition.chipAttributes.chipLimit
    ) {
      this.setState({
        chipLimit: fieldDefinition.chipAttributes.chipLimit,
      });
    }
  }

  handleItemDelete = (idx: number) => () => {
    const { value } = this.state;
    const { onChange } = this.props;

    var sVal = String(value);

    var chipVals = sVal.split("|");
    chipVals.splice(idx, 1);

    var newVal = chipVals.join("|");

    this.setState({ value: newVal }, () => {
      if (onChange) {
        onChange(newVal);
      }
    });
  };

  onBlur = (event: any) => {
    const { value } = this.state;
    const { onChange, fieldDefinition } = this.props;
    var sVal = String(value);
    if (sVal && sVal != "" && sVal[sVal.length - 1] != "|") {
      if (
        fieldDefinition &&
        fieldDefinition.chipAttributes &&
        fieldDefinition.chipAttributes.regex
      ) {
        var chipVals = sVal.split("|");
        var lastVal = chipVals[chipVals.length - 1];
        let m = lastVal.match(new RegExp(fieldDefinition.chipAttributes.regex));
        if (!m || m.length == 0) {
          this.setState({
            localError: "value does not match expected pattern",
          });
          return;
        } else {
          this.setState({ localError: null });
        }
      }
      sVal = sVal + "|";
      this.setState({ value: sVal, localError: null }, () => {
        if (onChange) {
          onChange(sVal);
        }
      });
    }
  };

  // Not currently used in a real context, but may be in the future
  onChipForward = (event: any) => {
    const { chipLimit, chipSkip, value } = this.state;
    event.stopPropagation();
    const { fieldDefinition } = this.props;

    var stringVal = String(value);
    var chipVals = stringVal.split("|");
    if (
      fieldDefinition &&
      fieldDefinition.chipAttributes &&
      fieldDefinition.chipAttributes.chipLimit
    ) {
      var newLimit = chipLimit + fieldDefinition.chipAttributes.chipLimit - 1;
      var newSkip = chipSkip + fieldDefinition.chipAttributes.chipLimit - 1;
      if (chipVals.length < newSkip) {
        this.setState({
          chipLimit: fieldDefinition.chipAttributes.chipLimit,
          chipSkip: 0,
        });
      } else {
        this.setState({ chipLimit: newLimit, chipSkip: newSkip });
      }
    }
  };

  // Not currently used in a real context, but may be in the future
  onChipBackward = (event: any) => {
    const { chipLimit, chipSkip, value } = this.state;
    event.stopPropagation();
    const { fieldDefinition } = this.props;

    var stringVal = String(value);
    var chipVals = stringVal.split("|");

    if (
      fieldDefinition &&
      fieldDefinition.chipAttributes &&
      fieldDefinition.chipAttributes.chipLimit
    ) {
      var newLimit = chipLimit - (fieldDefinition.chipAttributes.chipLimit - 1);
      var newSkip = chipSkip - (fieldDefinition.chipAttributes.chipLimit - 1);
      if (newSkip < 0) {
        newSkip =
          Math.floor(
            chipVals.length / fieldDefinition.chipAttributes.chipLimit
          ) *
          (fieldDefinition.chipAttributes.chipLimit - 1);
        newLimit = newSkip + fieldDefinition.chipAttributes.chipLimit;
        this.setState({ chipLimit: newLimit, chipSkip: newSkip });
      } else {
        this.setState({ chipLimit: newLimit, chipSkip: newSkip });
      }
    }
  };

  onToggleChipPopout = (event: any) => {
    const self = this;
    return function (evt: any) {
      if (self.state.popperOpen == -1) {
        self.setState({
          popperOpen: 1,
          anchorEl: evt.currentTarget,
        });
      } else {
        self.setState({
          popperOpen: -1,
          anchorEl: evt.currentTarget,
        });
      }
    };
  };

  onPaste = (event: any) => {
    const { onChange, fieldDefinition } = this.props;
    const {value} = this.state
    if (fieldDefinition.allowedCharacters) {
      navigator.clipboard
        .readText()
        .then((text) => {
          var ok = true;
          text.split("").forEach(function (c) {
            if ((fieldDefinition.allowedCharacters+"|").indexOf(c) == -1) {
              ok = false;
            }
          });
          if (!ok) {
            this.setState({ value: value, localWarning: "Invalid Character(s) detected in paste content" }, () => {
              if (onChange) {
                onChange(value);
              }
            });
          }
        })
        .catch((err) => {
          console.error("Failed to read clipboard contents: ", err);
        });
    }
  };

  onCopy = (event: any) => {
    const { chipLimit, chipSkip, value } = this.state;
    event.stopPropagation();
    navigator.clipboard.writeText(value).then(
      function () {
        /* clipboard successfully set */

      },
      function () {
        /* clipboard write failed */

      }
    );
  };

  onInputKeyDown = () => (evt: any) => {
    const { value } = this.state;
    const { fieldDefinition } = this.props;
    var self = this;
    if (evt.keyCode == 9 || evt.keyCode == 13) {
      var sVal = String(value);
      if (sVal && sVal != "" && sVal[sVal.length - 1] != "|") {
        evt.preventDefault();
        this.onBlur(evt);
      }
    } else if (evt.keyCode == 220 && evt.shiftKey) {
      evt.preventDefault();
    }
  };

  handleClickAway = () => {
    const self = this;
    // return function(event: any) {
    if (self.state.popperOpen) {
      self.setState({
        popperOpen: -1,
      });
    }
    // }
  };

  determineMaxChips = () => {
    const { chipLimit } = this.state;
    const { fieldDefinition } = this.props;
    var fieldWidth = 500;
    if (this.fieldRef && this.fieldRef.current) {
      fieldWidth = this.fieldRef.current.getBoundingClientRect().width;
    }

    var chipStyle;
    if (
      fieldDefinition.chipAttributes &&
      fieldDefinition.chipAttributes.styleAttributes
    ) {
      chipStyle = fieldDefinition.chipAttributes.styleAttributes;
    }

    var maxWidth = 150;
    if (
      fieldDefinition.chipAttributes &&
      fieldDefinition.chipAttributes.maxWidth
    ) {
      maxWidth = fieldDefinition.chipAttributes.maxWidth;
      if (!chipStyle) {
        chipStyle = {
          maxWidth: maxWidth,
        };
      } else {
        chipStyle.maxWidth = maxWidth;
      }
    }
    var maxChips = 0;

    var collectiveWidth = 0;
    var lastWidth = 0;
    for (let ref of this.chipsRef) {
      if (ref) {
        var rect = ref.getBoundingClientRect();
        if (rect) {
          if (rect.width) {
            lastWidth = rect.width;
          }

          collectiveWidth += (rect.width || lastWidth || maxWidth) + 8;
          if (collectiveWidth > fieldWidth - maxWidth + 8) {
            // break
          } else {
            maxChips++;
          }
        } else {
        }
      }
    }

    // if there are not enough refs to fill up the width, maxChips should be bigger than the number of chips, as none should be hidden
    if (collectiveWidth <= fieldWidth - (maxWidth + 8)) {
      maxChips = this.chipsRef.length;
    }
    if (maxChips < chipLimit) {
      return { maxChips, collectiveWidth };
    } else {
      return { maxChips: chipLimit, collectiveWidth: collectiveWidth };
    }
  };

  determineChipStyle = (maxWidthOverride?: number) => {
    const { fieldDefinition } = this.props;
    var maxWidth = 150;
    if (maxWidthOverride && maxWidthOverride != 0) {
      maxWidth = maxWidthOverride;
    }
    var chipStyle;
    if (
      fieldDefinition.chipAttributes &&
      fieldDefinition.chipAttributes.styleAttributes
    ) {
      chipStyle = fieldDefinition.chipAttributes.styleAttributes;
    }

    if (
      fieldDefinition.chipAttributes &&
      fieldDefinition.chipAttributes.maxWidth &&
      !maxWidthOverride
    ) {
      maxWidth = fieldDefinition.chipAttributes.maxWidth;
    }
    if (!chipStyle) {
      chipStyle = {
        maxWidth: maxWidth,
      };
    } else {
      chipStyle.maxWidth = maxWidth;
    }
    return chipStyle;
  };

  renderAllChips = () => {
    const { classes }: { classes: ClassNameMap } = this.props;
    const { value, chipLimit, chipSkip, localError, popperOpen } = this.state;
    const { fieldDefinition } = this.props;

    var stringVal = String(value);
    var chipVals = stringVal.split("|");

    var { maxChips, collectiveWidth } = this.determineMaxChips();
    var chipStyle = this.determineChipStyle(225);

    var odFn;
    
    var chips = chipVals.map((v: string, idx) => {
      if (v != "") {
        if (fieldDefinition.mode != "Display" && fieldDefinition.mode != "Read Only") {
          odFn = this.handleItemDelete(idx);
        }
    
        if ((idx >= maxChips - 1 || idx < chipSkip) && maxChips != -1) {
          return (
            <Chip
              key={idx}
              tabIndex={-1}
              size={"small"}
              style={chipStyle}
              disabled={this.props.disabled}
              label={v}
              title={v}
              className={classes.chip}
              onDelete={odFn}
            />
          );
        }
      }
    });
    return chips;
  };

  render() {
    const { classes }: { classes: ClassNameMap } = this.props;
    const {
      className,
      style,
      disabled,
      error,
      helperText,
      id,
      fieldDefinition,
      InputLabelProps,
      inputRef,
      InputProps,
      inputProps,
      label,
      name,
      placeholder,
      required,
      type,
      labelStyleObj,
      shrink,
      margin,
      onBlur,
      onChange,
      onKeyPress,
      onCommitChange,
      onKeyDown,
      precision,
      isKeyField,
    } = this.props;
    const { value, chipLimit, chipSkip, localError,localWarning, popperOpen } = this.state;

    var ip = InputProps ? extend({}, InputProps) : {};
    // var fieldValue = value as string
    var stringVal = String(value);
    var chipVals = stringVal.split("|");
    var showLast = false;
    if (stringVal.charAt(stringVal.length - 1) == "|") {
      showLast = true;
    }

    var overflowed = false;
    if (chipVals.length >= chipLimit - 1 && chipLimit != -1) {
      overflowed = true;
    }
    var useCarosel = false;
    if (
      fieldDefinition.chipAttributes &&
      fieldDefinition.chipAttributes.useCarosel
    ) {
      useCarosel = true;
    }

    var { maxChips, collectiveWidth } = this.determineMaxChips();

    if (this.lastMaxChips && this.lastMaxChips != -1 && !showLast) {
      maxChips = this.lastMaxChips;
    } else {
      this.lastCollectiveWidth = collectiveWidth;
      this.lastMaxChips = maxChips;
    }

    var chipStyle = this.determineChipStyle();

    var chips = chipVals.map((v: string, idx) => {
      
      var odFn;
      if (fieldDefinition.mode != "Display" && fieldDefinition.mode != "Read Only") {
        odFn = this.handleItemDelete(idx);
      }

      if (
        v != "" &&
        (idx != chipVals.length - 1 ||
          (showLast && idx == chipVals.length - 1) ||
          fieldDefinition.mode == "Display")
      ) {
        let itemCount = chipVals.length - maxChips;
        var open = false;
        if (popperOpen != -1) {
          open = true;
        }
        if (idx + 1 == maxChips && itemCount != 1) {
          if (useCarosel) {
            return;
          } else {
            overflowed = true;
            var allChips = this.renderAllChips();
            return (
              <div>
                <Chip
                  key={idx}
                  tabIndex={-1}
                  size={"small"}
                  label={"+" + itemCount + " more..."}
                  title={"+" + itemCount + " more..."}
                  disabled={this.props.disabled}
                  className={classes.chip}
                  ref={(node: any) => {
                    this.popperNode = node;
                    this.chipsRef[idx] = null;
                  }}
                  clickable={true}
                  onClick={this.onToggleChipPopout(1)}
                />
                <div>
                  <Popper
                    style={{ zIndex: 99999 }}
                    placement={"bottom-end"}
                    open={open}
                    // anchorEl={this.state.anchorEl}
                    anchorEl={this.popperNode}
                    transition
                  >
                    {({ TransitionProps }) => (
                      <ClickAwayListener onClickAway={this.handleClickAway}>
                        <Fade {...TransitionProps} timeout={350}>
                          <Paper
                            className={classes.popperPaper}
                            style={{ width: 250, padding: 5, overflow: "wrap" }}
                          >
                            {allChips}
                          </Paper>
                        </Fade>
                      </ClickAwayListener>
                    )}
                  </Popper>
                </div>
              </div>
            );
          }
        } else if ((idx >= maxChips || idx < chipSkip) && maxChips != -1) {
          var hiddenChipStyle = cloneDeep(chipStyle);
          hiddenChipStyle.display = "none";

          return (
            <Chip
              key={idx}
              tabIndex={-1}
              size={"small"}
              style={hiddenChipStyle}
              disabled={this.props.disabled}
              // ref={el => this.chipsRef.current[idx] = el}
              ref={(ref) => {
                this.chipsRef[idx] = ref;
                return true;
              }}
              label={v}
              title={v}
              className={classes.chip}
              onDelete={odFn}
            />
          );
        } else {
          return (
            
            <Chip
              key={idx}
              tabIndex={-1}
              size={"small"}
              style={chipStyle}
              disabled={this.props.disabled}
              // ref={el => this.chipsRef.current[idx] = el}
              ref={(ref) => {
                this.chipsRef[idx] = ref;
                return true;
              }}
              label={v}
              title={v}
              className={classes.chip}
              onDelete={odFn}
            />
          );
        }
      }
    });

    if (chipVals.length > 1) {
      InputProps["startAdornment"] = (
        <InputAdornment position="start">{chips}</InputAdornment>
      );
      if (overflowed && useCarosel) {
        InputProps["endAdornment"] = (
          <InputAdornment position="end">
            <IconButton
              fontSize="small"
              aria-label="backward"
              onClick={this.onChipBackward}
            >
              <i className={"fa fa-chevron-left"} />
            </IconButton>
            <IconButton
              fontSize="small"
              aria-label="foward"
              onClick={this.onChipForward}
            >
              <i className={"fa fa-chevron-right"} />
            </IconButton>
          </InputAdornment>
        );
      }
    }
    var isCopyable;
    if (
      fieldDefinition.chipAttributes &&
      fieldDefinition.chipAttributes.isCopyabale
    ) {
      if (
        fieldDefinition.chipAttributes.isCopyabale ||
        fieldDefinition.chipAttributes.isCopyabale == "true"
      )
        isCopyable = true;
    }

    if (fieldDefinition.mode == "Display") {
      return (
        <FormControl className={className} style={style}>
          {label}
          <div name={fieldDefinition.key} className={classes.displayText}>
            {chips}
          </div>
        </FormControl>
      );
    } else {
      var helperTextString = helperText;
      var fielderror = error;
      if (localError && !error) {
        helperTextString = localError;
        fielderror = true;
      } else if (localWarning) {
        helperTextString = localWarning
      }
      
      return (
        <TextField
          type={type}
          ref={this.fieldRef}
          required={required}
          // id={fd.key}
          name={name || id}
          // displayValue={chipVals[chipVals.length-1] || ""}
          value={chipVals[chipVals.length - 1] || ""}
          label={
            <span>
              {fieldDefinition.title}
              {fieldDefinition.mode == "Key Field" && (
                <i
                  style={{ color: "#CD5C5C", marginLeft: 5 }}
                  className="fa fa-key"
                  onClick={this.onCopy}
                ></i>
              )}
              {isCopyable && (
                <i
                  style={{cursor:'pointer', marginLeft: 5 }}
                  className="fal fa-copy"
                  onClick={this.onCopy}
                ></i>
              )}
            </span>
          }
          className={className}
          placeholder={placeholder}
          onChange={onChange}
          //This InputProps (capital I) is for the underlying Material IU Input component (which does not care about maxLenght, for example
          InputProps={InputProps}
          //This inputProps (little i) is for the html input control at the bottom.
          inputProps={inputProps}
          InputLabelProps={{
            style: labelStyleObj,
            shrink: (shrink !== false || (value != null && value.length > 0)).toString(),
          }}
          onKeyDown={this.onInputKeyDown()}
          onKeyPress={onKeyPress}
          onBlur={this.onBlur}
          onPaste={this.onPaste}
          error={fielderror}
          helperText={helperTextString}
          disabled={this.props.disabled}
          multiline={fieldDefinition.variant == "TextArea" ? true : false}
          style={style}
        />
      );
    }
  }
}

export default withStyles(styles)(ChipField);
